import React from 'react';
import Fade from 'react-reveal/Fade';

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from './styles/landing.module.css';
import { APP_NAME } from './constants';
import AppTitle from './components/AppTitle';
import DownloadButtons from './components/DownloadButtons';
import assets from './assets';

import BaseScreen from './BaseScreen';
import paths from './paths';
import InputText from './components/InputText';
import { useState } from 'react';
import {subscribeEmail} from './api'

function LandingPage() {

	const [email, setEmail] = useState('');
	const [submitted, setSubmitted] = useState(false);

	const validateEmail = () => {
		var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/;
		if (!email.match(mailformat)) {
			alert('Please enter a valid email')
			return false;
		}
		return true;
	};

	const onSubmit = async (e) => {
		e.preventDefault()
		
		if (validateEmail()) {
			try {
				const res = await subscribeEmail(email);
				
				if(res.ok){
					setSubmitted(true)
					setEmail('')
				}
			} catch (error) {
				console.log(error);
			}
		}
	};

	const renderForm = () => {
		return (
			<form
				name="contact"
				onSubmit={onSubmit}
			>
				<InputText
					name="email"
					placeholder="Email *"
					onChange={(e) => {
						const { value } = e.target
						setEmail(value);
					}}
					value={email}
				/>
				<div style={{ width: '10px' }} />
				<button type="submit">
					Submit
				</button>
			</form>
		)
	}

	return (
		<BaseScreen>
			<div className={styles.container}>
				<Fade>
					<Fade bottom>
						<img
							className={styles.imageScreenshots}
							alt={`${APP_NAME} app Screenshots`}
							src={assets.screenshots}
						/>
						<a href={paths.gallery}>
							<div className={styles.gallery}>
								<div style={{ paddingRight: "5px" }}>
									View more in gallery
								</div>
								<FontAwesomeIcon icon={faArrowRight} />
							</div>
						</a>
					</Fade>
					<div className={styles.appDescriptionContainer}>
						<AppTitle />
						<Fade right>
							<h1>The Best COVID-19 Tracker you can get.</h1>
						</Fade>
						<div>
							Let’s Stop Covid is your all-in-one app that everyone needs to stay updated on the latest statistics, news and information of coronavirus (COVID-19). It also allows you to share your words of encouragement with the rest of the world!
						</div>
						<DownloadButtons />
						<div className={styles.notify}>
							{
								submitted 
									? <>
									Got it!
									<br/>
									We will send you an email when the app is released.
									</>
									: "Notify me when it's released!"
							}
							{!submitted && renderForm()}
						</div>
					</div>
				</Fade>
			</div>
		</BaseScreen>
	);
}

export default LandingPage;
